import React, { useEffect, useState } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './EntryTacticsModules.module.css';
import PropTypes from 'prop-types';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import CandleBreakDocs from '../../../../documentation/CandleBreakDocumentation';
import CheckBox from '../../../../../../atomic/formElements/checkBox/CheckBox';

function CandleBreakModule({ state, top }) {
  const [candleBreak, dispatchCandleBreak, , setCandleBreakEnabled] = state;
  const [amountDisplay, setAmountDisplay] = useState('');
  const [candleDurationDisplay, setCandleDurationDisplay] = useState('');
  const [breakByDisplay, setBreakByDisplay] = useState('');

  useEffect(() => {
    setCandleBreakEnabled(true);
  }, []);

  useEffect(() => {
    setAmountDisplay(candleBreak.quantityBasisValue ?? 0);
    setCandleDurationDisplay(candleBreak.candleDuration ?? 0);
    setBreakByDisplay(candleBreak.breakBy ?? 0);
  }, [candleBreak]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={CandleBreakDocs} /> Candle Break
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>
            {top.quantityBasis === 'DOLLARS' ? 'Dollar' : 'Qty.'} Amount
          </p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) =>
              dispatchCandleBreak({ quantityBasisValue: value })
            }
          >
            {top.quantityBasis === 'DOLLARS' ? '$' : '#'}
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Candle Duration</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={candleDurationDisplay}
            setValue={setCandleDurationDisplay}
            onBlur={(value) => dispatchCandleBreak({ candleDuration: value })}
          >
            min.
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Break By</p>
          <NumberInputWithUnit
            direction="left"
            type="number"
            value={breakByDisplay}
            setValue={setBreakByDisplay}
            onBlur={(value) => dispatchCandleBreak({ breakBy: value })}
          >
            $
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p style={{ whiteSpace: 'nowrap', fontSize: '10px' }}>Wait for Cndl. Close</p>
          <CheckBox
            checked={candleBreak.waitUntilCurrentCandleCloses}
            onChange={(checked) =>
              dispatchCandleBreak({ waitUntilCurrentCandleCloses: checked })
            }
          />
        </div>
      </div>
    </div>
  );
}
CandleBreakModule.propTypes = {
  state: PropTypes.array.isRequired,
  top: PropTypes.object.isRequired,
};
export default CandleBreakModule;
